import { DurationService } from '@mews/framework';

export const getCombinedDurationString = (base: string | null, additional: string | null) => {
    const firstObj = base != null && DurationService.toObject(DurationService.parse(base));
    const secondObj = additional != null && DurationService.toObject(DurationService.parse(additional));
    const combined = DurationService.fromObject({ ...firstObj, ...secondObj });
    return DurationService.toString(combined);
};
